/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_FormatInputs */

const en_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Format`)
};

const fr_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-formatage`)
};

const de_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierung`)
};

const it_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato automatico`)
};

const ru_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоформатирование`)
};

const es_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato automático`)
};

const zh_cn2_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式`)
};

const ja_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動フォーマット`)
};

const hi_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो फॉर्मेट`)
};

const pt_pt2_auto_format = /** @type {(inputs: Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática`)
};

/**
* | output |
* | --- |
* | "Auto Format" |
*
* @param {Auto_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format = /** @type {((inputs?: Auto_FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_format(inputs)
	if (locale === "de") return de_auto_format(inputs)
	if (locale === "it") return it_auto_format(inputs)
	if (locale === "ru") return ru_auto_format(inputs)
	if (locale === "es") return es_auto_format(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_format(inputs)
	if (locale === "ja") return ja_auto_format(inputs)
	if (locale === "hi") return hi_auto_format(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_format(inputs)
	return en_auto_format(inputs)
});